import { AnyHandler } from '../types/@types/sl-v-types';
import { EventEmitter } from '@angular/core';

export class NonBlockingIterator {
	public dataSrc: Array<any> | object;
	public objKeys: Array<any>;
	public isObject = false;
	public startI: number;
	public endI: number;
	public currentI: number;
	public itemHandler: AnyHandler;
	public completeHandler: AnyHandler;
	public currentTimeout: number;
	public skip = 1;
	constructor(dataSrc: Array<any> | object, completeHandler: AnyHandler) {
		this.dataSrc = dataSrc;
		this.completeHandler = completeHandler;

		if (dataSrc instanceof Array) {
			this.isObject = false;
		} else {
			this.objKeys = Object.keys(dataSrc);
			this.isObject = true;
		}
	}
	SetCompleteHandler(newHandler: AnyHandler): NonBlockingIterator {
		this.completeHandler = newHandler;
		return this;
	}
	For(start: number, length: number, skip: number = 1, itemHandler) {
		this.skip = skip;
		this.startI = start;
		this.endI = start + length - 1;
		this.currentI = this.startI;

	}
	ForEach(itemHandler) {
		if (this.isObject === true) {
			this.ForIn(itemHandler);
		} else {
			this.ForOf(itemHandler);
		}
	}
	ForIn(itemHandler) {
		this.startI = 0;
		this.endI = this.objKeys.length - 1;
		this.currentI = this.startI;
		this.NextItem(itemHandler);
	}
	ForOf(itemHandler) {
		this.startI = 0;
		this.endI = this.startI + (this.dataSrc as Array<any>).length - 1;
		this.currentI = this.startI;
		this.NextIndex(itemHandler);
	}
	NextItem(itemHandler) {
		if (this.currentI > this.endI) {
			this.Halt();
			return;
		}
		this.itemHandler = itemHandler;

		if (this.dataSrc.hasOwnProperty(this.objKeys[this.currentI]) === false) {
			this.currentI += this.skip;
			this.NextItem(itemHandler);
			return;
		}
		itemHandler({ item: this.dataSrc[this.objKeys[this.currentI]], key: this.objKeys[this.currentI], itr8: this });
		if (this.currentI === this.endI) {
			this.completeHandler(this);
			this.currentI += this.skip;
			this.Halt();
		}
		this.currentI += this.skip;
		this.currentTimeout = window.setTimeout(() => {
			window.clearTimeout(this.currentTimeout);
			this.currentTimeout = undefined;
			this.NextItem(itemHandler)
		}, 1);

	}
	NextIndex(itemHandler) {
		if (this.currentI > this.endI) {
			this.Halt();
			return;
		}
		this.itemHandler = itemHandler;
		
		itemHandler({ item: this.dataSrc[this.currentI], index: this.currentI, itr8: this });
		if (this.currentI === this.endI) {
			this.completeHandler(this);
			this.Halt();
			return;
		}
		this.currentI += this.skip;
		this.currentTimeout = window.setTimeout(() => {
			window.clearTimeout(this.currentTimeout);
			this.currentTimeout = undefined;
			this.NextIndex(itemHandler)
		}, 1);
	}
	Halt() {
		if (!!this.currentTimeout) {
			window.clearTimeout(this.currentTimeout);
			this.currentTimeout = undefined;
		}
	}
	Continue() {
		if (this.isObject) {
			this.NextItem(this.itemHandler);
		} else {
			this.NextIndex(this.itemHandler);
		}
	}
	SetIndex(index: number) {
		this.currentI = 1;
	}
	SetEndIndex(index: number) {
		this.endI = index;
	}
	ChangeLength(length: number) {
		this.SetEndIndex(this.startI + length - 1);
	}
	AppendKeys(keys: Array<string>) {
		for (const key of keys) {
			this.objKeys.push(key);
		}
	}


}